import Italic from "@tiptap/extension-italic";

declare module "@tiptap/core" {
	interface Commands<ReturnType> {
		italic_em: {
			setItalic_em:    () => ReturnType;
			toggleItalic_em: () => ReturnType;
			unsetItalic_em:  () => ReturnType;
		};
	}
}

// Preserve <em> tags for italics
export const CustomItalics_em = Italic.extend({
	name: "italic_em",
	addCommands() {
		return {
			setItalic_em: () => ({commands}) => {
				return commands.setMark("italic_em");
			},
			toggleItalic_em: () => ({commands}) => {
				return commands.toggleMark("italic_em");
			},
			unsetItalic_em: () => ({commands}) => {
				return commands.unsetMark("italic_em");
			}
		};
	},
	parseHTML() {
		return [{
			tag: "em"
		}];
	}
});
